module.exports = { 
      attributes: {"title":"Ergebnisse","categories":["shogi"],"tags":["shogi"],"language":"de","section":"shogi","slug":"result"},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_c('iframe',{attrs:{"src":"https://www.shogi-berlin.de/esc2018/mainResult.html","frameborder":"0","width":"100%","height":"500"}})])]) }];
          }
        }
      },
     }